import BookingForm from './BookingForm.vue'
import BookingFormNoLine from './BookingFormNoLine.vue'

export default {
  BookingForm,
  BookingFormNoLine
}



// WEBPACK FOOTER //
// ./src/components/TheMall/index.js